module.exports = __webpack_public_path__ + "img/img_push.cc3107da.png";